<template>
  <div
    id="wy-player"
    v-show="isShowVideo"
    :style="{opacity: `${isShowVideo? '1': '0'}`}"
  >
    <div id="dplayer">

    </div>
    <div class="dplayer-mobile-play-mask add-like" v-if="!isPC()">
      <likesMask :live="live" />
    </div>
  </div>

</template>
<script>
import DPlayer from 'dplayer';
import Vue from 'vue';
import { cloneDeep } from 'lodash';
import wx from 'weixin-js-sdk';
import defaultOptions from './option';
// 直播点赞组件
import likesMask from './likes-mask/index.vue';

export default {
  name: 'dplayer',
  components: {
    likesMask,
  },
  data() {
    return {
      el: null,
      playerOptions: cloneDeep(defaultOptions),
      isShowVideo: false,
      // screenHeight: 0,
    };
  },
  props: {
    live: {
      type: Boolean,
      default: false,
    },
    playUrl: String,
    pic: String,
  },
  watch: {
    playUrl: {
      handler(newval) {
        if (newval.indexOf('.mp4') !== -1) {
          this.playerOptions.video.type = 'auto';
        }
        if (this.pic) {
          this.playerOptions.video.pic = this.pic;
        }
        this.playerOptions.video.url = newval;
        this.init();
      },
    },
  },
  methods: {
    isPC() {
      const userAgentInfo = navigator.userAgent;
      const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      let flag = true;
      for (let v = 0; v < Agents.length; v += 1) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    X5wechat() {
      // 微信X5浏览器特殊处理
      const video = document.querySelector('video');
      video.setAttribute('x5-video-player-type', 'h5');
      video.setAttribute('x5-video-player-fullscreen', 'true');
      video.setAttribute('x5-video-orientation', 'portrait');
      video.setAttribute('autoplay', 'autoplay');
      video.setAttribute('muted', 'true');
      // video.style.height = `${this.screenHeight}px`;
      // 进入全屏，设置状态
      video.addEventListener('x5videoenterfullscreen', () => {
        this.$store.commit('changeSeting', { key: 'x5videoenterfullscreen', value: true });
      }, false);
      video.addEventListener('x5videoexitfullscreen', () => {
        this.$store.commit('changeSeting', { key: 'x5videoenterfullscreen', value: false });
      }, false);
    },
    init() {
      // this.screenHeight = window.innerHeight;
      this.el = document.getElementById('dplayer');
      this.videoDestroy();
      const player = new DPlayer({
        container: this.el,
        ...this.playerOptions,
      });
      this.X5wechat();

      const { events } = player;
      // eslint-disable-next-line consistent-return
      Object.keys(events).forEach(item => {
        if (item === 'events') {
          return false;
        }
        events[item].forEach(event => {
          player.on(event, () => this.$emit(event));
        });
      });
      Vue.prototype.$player = player;
      if (this.live) {
        player.fullScreen.request('web');
      }

      setTimeout(() => {
        this.isShowVideo = true;
      }, 500);

      document.addEventListener('WeixinJSBridgeReady', () => {
        setTimeout(() => {
          // eslint-disable-next-line no-unused-expressions
          player.play();
        }, 500);
      }, false);

      wx.config({
        debug: false,
        appId: '',
        timestamp: 1,
        nonceStr: '',
        signature: '',
        jsApiList: [],
      });

      wx.ready(() => {
        setTimeout(() => {
          // eslint-disable-next-line no-unused-expressions
          player.play();
        }, 500);
      });

      if (this.$UA.isUserApp) {
        const dplayerIcon = document.querySelector('.dplayer-mobile-play');
        if (dplayerIcon) dplayerIcon.style.display = 'none';
      }
      player.play();
    },
    // 销毁
    videoDestroy() {
      if (this.$player) {
        this.$player.fullScreen.cancel('web');
        this.$player.destroy();
      }
      if (this.$hls) {
        this.$hls.destroy();
      }
    },
  },
  beforeDestroy() {
    this.videoDestroy();
  },
  mounted() {
    setTimeout(() => {
      if (this.isPC()) {
        document.getElementsByTagName('html')[0].style.fontSize = '50px';
        window.onresize = () => {
          document.getElementsByTagName('html')[0].style.fontSize = '50px';
        };
      }
    }, 500);
  },
};
</script>
<style lang="less">
#wy-player {
  transition: 1s;
  .dplayer-mobile-play{
    /* prettier-ignore */
    width: auto;
    height: 80PX;
    line-height: 80PX;
    text-align: center;
    svg{
      vertical-align: middle;
      /* prettier-ignore */
      width: 68PX;
      height: 50PX;
      text-align: center;
    }
  }
  .dplayer-mobile-play-mask{
    background-color: transparent;
    position: absolute;
    z-index: 100002;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .dplayer-controller,
  .dplayer-controller-mask {
    display: none;
  }
  .dplayer-notice{
    display: none;
  }
  video {
    mix-blend-mode: screen;
    width: auto !important;
    // object-fit: fill;
  }
  .dplayer-video-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dplayer-playing {
      .dplayer-mobile-play {
        display: none!important;
    }
  }
}
</style>
